import React, { useMemo } from 'react';
import { LFC } from '../../Legacy';
import { Prompt } from '../../ui';
import { BigButton } from '../../ui/BigButton';
import { Notice } from '../../ui/Notice';
import { useResolve } from '../Container';
import { PassportModel, UserRole } from '../PassportModel';
import { useDashboardVersion } from '../account/AccountHooks';
import { HideIfHasFeature, useFeatureCheck } from '../common/FeatureElements';
import { Copy, Flexer, Title } from '../dashboard/elements/LayoutElements';
import { Popup, PopupProps } from '../popups/Popup';

export const selectUserRolePopup = () => ({ ui: SelectUserRolePopup });

export const SelectUserRolePopup: LFC<PopupProps> = ({ action, dismiss }) => {

    const passport = useResolve(PassportModel);
    const accessControl = useFeatureCheck('accessControl');
    const version = useDashboardVersion();

    const options = useMemo(
        () => UserRole.options(passport).filter(x => version !== 'next' || x.name !== 'account_guest'),
        [version]);

    return <Prompt ignoreEnter onAction={dismiss}>
        <Popup w={38}>
            <Popup.Close onAction={dismiss} />
            <Popup.Title>Change Role</Popup.Title>
            <Popup.Content>
                <Copy>
                    Please select a new role for this person:
                </Copy>
                {options.map(x =>
                    <Flexer key={x.name} margin=".5 0" disabled={(x.name === 'account_guest' && !accessControl)}>
                        <BigButton onClick={() => action(x)}>
                            <BigButton.Inner expand>
                                <Title size="md">{x.label}</Title>
                                <Copy>{x.desc}</Copy>
                            </BigButton.Inner>
                        </BigButton>
                    </Flexer>
                )}
                <HideIfHasFeature name="accessControl">
                    <Flexer flex="row" center margin=".5 0 0">
                        <Notice icon="upgrade" text="Upgrade to get guests - invite external users to your boards, no sign-in required." />
                    </Flexer>
                </HideIfHasFeature>
            </Popup.Content>
        </Popup>
    </Prompt>;
};


